export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">精彩看点</h2>
          <p className="mt-3 text-sm text-foreground-600">韩国漫画热门话题视频 · 抢先预览</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          <div className="bg-background-100 rounded-lg overflow-hidden group cursor-pointer">
            <div className="relative w-full aspect-video overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20themed%20illustration%20showing%20a%20dramatic%20scene%20of%20a%20romantic%20encounter%20in%20a%20rainy%20Seoul%20street%20at%20night%2C%20warm%20neon%20lights%20reflecting%20on%20wet%20pavement%2C%20intimate%20atmosphere%2C%20soft%20coral%20and%20amber%20glow%2C%20cinematic%20webtoon%20style%20digital%20art&width=800&height=450&seq=media-01&orientation=landscape"
                alt="韩国漫画 - 十大浪漫名场面盘点"
                title="好看的韩国漫画推荐 | 浪漫名场面"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-12 h-12 rounded-full bg-white/90 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-white transition-colors">
                  <i className="ri-play-fill text-xl text-primary-500 group-hover:text-white transition-colors ml-0.5"></i>
                </div>
              </div>
            </div>
            <div className="p-4">
              <h3 className="text-sm font-medium text-foreground-900">十大韩国漫画浪漫名场面盘点</h3>
              <p className="text-xs text-foreground-500 mt-1">那些让人心跳加速的经典瞬间</p>
            </div>
          </div>

          <div className="bg-background-100 rounded-lg overflow-hidden group cursor-pointer">
            <div className="relative w-full aspect-video overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20dynamic%20Korean%20manhwa%20style%20illustration%20of%20an%20epic%20battle%20scene%20between%20warriors%20with%20glowing%20weapons%2C%20dramatic%20clash%20of%20energies%2C%20warm%20fiery%20background%2C%20action%20packed%20composition%2C%20webtoon%20digital%20art%20with%20cinematic%20lighting&width=800&height=450&seq=media-02&orientation=landscape"
                alt="韩国漫画 - 动作漫画燃爆瞬间"
                title="韩国漫画高分推荐 | 燃爆瞬间"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-12 h-12 rounded-full bg-white/90 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-white transition-colors">
                  <i className="ri-play-fill text-xl text-primary-500 group-hover:text-white transition-colors ml-0.5"></i>
                </div>
              </div>
            </div>
            <div className="p-4">
              <h3 className="text-sm font-medium text-foreground-900">热血沸腾！韩国动作漫画巅峰对决</h3>
              <p className="text-xs text-foreground-500 mt-1">打斗场面最炸裂的高分作品巡礼</p>
            </div>
          </div>

          <div className="bg-background-100 rounded-lg overflow-hidden group cursor-pointer">
            <div className="relative w-full aspect-video overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20themed%20illustration%20of%20a%20cozy%20reading%20nook%20with%20a%20digital%20tablet%20displaying%20a%20colorful%20webtoon%20page%2C%20warm%20ambient%20lighting%2C%20surrounded%20by%20art%20prints%20and%20snacks%2C%20comfortable%20atmosphere%2C%20soft%20coral%20and%20golden%20tones&width=800&height=450&seq=media-03&orientation=landscape"
                alt="韩国漫画 - 新人入坑指南"
                title="好看的韩国漫画大全 | 入坑指南"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-12 h-12 rounded-full bg-white/90 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-white transition-colors">
                  <i className="ri-play-fill text-xl text-primary-500 group-hover:text-white transition-colors ml-0.5"></i>
                </div>
              </div>
            </div>
            <div className="p-4">
              <h3 className="text-sm font-medium text-foreground-900">韩国漫画新人入坑指南</h3>
              <p className="text-xs text-foreground-500 mt-1">从零开始找到最适合你的必看漫画</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}